import { useSelector } from 'react-redux';

import useLocalStorageSync from '@app/hooks/useLocalStorageSync';
import { getUserID } from '@app/store/user/user/selectors';

export default function useTourMode() {
  const userId = useSelector(getUserID);
  return useLocalStorageSync<boolean>(`modusign__tourMode_${userId}`, false);
}
